import styled from 'styled-components';

export const ContainerRegistry = styled.section`
	.title {
		color: #707070;
		font-family: Poppins-Medium, Heltica, Arial, sans-serif;
		font-size: 15px;
		margin-bottom: 0;
	}

	.panel-wrapper.show {
		position: relative;

		.panel {
			position: relative;
			max-height: 450px;
			overflow: hidden;
			transition: max-height .5s ease;
		}
	}
`;
